import { render } from "./site-header-link.vue?vue&type=template&id=7b67c0ac"
import script from "./site-header-link.vue?vue&type=script&lang=js"
export * from "./site-header-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__